import React from 'react';
import { 
  Box, 
  Container, 
  Card,
  CardContent,
  Button,
  Chip,
  Typography
} from '@mui/material';

const SystemOverviewTabs = ({ onExploreTopic, activeTopic }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ py: 3 }}>
        <Container maxWidth="xl">
          <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
            <Box sx={{ textAlign: 'center', mb: 10 }}>
              <Typography variant="h2" component="h2" sx={{ fontWeight: 'bold', mb: 4, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
                Comprehensive Breast Cancer Clinical Research
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.6, fontWeight: 500, fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
                MammoTrials connects breast cancer patients with life-saving clinical trials through AI-powered matching, mCODE integration, and comprehensive support across Florida's leading cancer research centers.
              </Typography>
            </Box>

            <Box
              sx={{
                mb: 6,
                display: 'grid',
                gap: 3,
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, minmax(0, 1fr))',
                  md: 'repeat(4, minmax(0, 1fr))'
                }
              }}
            >
              {[
                { icon: '📋', title: 'Protocols & Resources', desc: 'Unified access to standardized mammography trial protocols, clinical guidelines, educational materials, patient guides, and a comprehensive resource library for informed decision-making.', color: 'primary' },
                { icon: '🔬', title: 'Clinical Trials', desc: 'Comprehensive database of active breast cancer clinical trials with real-time enrollment status and eligibility matching.', color: 'success' },
                { icon: '🏥', title: 'Clinics & Provider Network', desc: 'Network of certified mammography centers and breast cancer treatment facilities across Florida, connected with oncologists, radiologists, and research specialists collaborating on clinical trials.', color: 'info' },
                { icon: '🤝', title: 'Community Support', desc: 'Patient navigation services, support groups, and community resources to assist patients and families during clinical trials.', color: 'warning' }
              ].map((item, index) => (
                <Box key={index}>
                    {(() => {
                      const isActive = activeTopic?.title === item.title;
                      return (
                  <Card sx={{
                    height: '100%',
                    cursor: 'pointer',
                    transition: 'all 0.3s',
                    border: 2,
                      borderColor: isActive ? `${item.color}.main` : 'grey.100',
                      bgcolor: isActive ? `${item.color}.main` : 'background.paper',
                      color: isActive ? 'white' : 'inherit',
                    '&:hover': {
                      boxShadow: 8,
                      borderColor: `${item.color}.main`,
                      transform: 'translateY(-4px)'
                    }
                  }}>
                    <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                      <Box sx={{
                        width: 56,
                        height: 56,
                          bgcolor: isActive ? 'rgba(255,255,255,0.2)' : `${item.color}.main`,
                        borderRadius: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 3,
                        fontSize: '1.4rem',
                        color: 'white',
                        boxShadow: 3,
                        transition: 'transform 0.3s',
                        '&:hover': { transform: 'scale(1.1)' }
                      }}>
                        {item.icon}
                      </Box>
                      <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 2, color: isActive ? 'white' : 'text.primary' }}>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color={isActive ? 'inherit' : 'text.secondary'} sx={{ lineHeight: 1.6, flex: 1, opacity: isActive ? 0.95 : 1 }}>
                        {item.desc}
                      </Typography>
                      <Button
                        variant="text"
                        size="small"
                        onClick={() => onExploreTopic?.({ title: item.title, color: item.color })}
                        sx={{
                          mt: 2,
                          alignSelf: 'flex-start',
                          color: isActive ? 'white' : `${item.color}.main`,
                          '&:hover': { bgcolor: isActive ? 'rgba(255,255,255,0.2)' : `${item.color}.light` }
                        }}
                      >
                        {isActive ? 'Agent active' : 'Click to explore'}
                      </Button>
                    </CardContent>
                  </Card>
                      );
                    })()}
                </Box>
              ))}
            </Box>
          </Container>
        </Container>
      </Box>
    </Box>
  );
};

export default SystemOverviewTabs;